<template>
  <div class="regist">
    <div class="layout">
      <!-- 一覧 -->
      <aside class="list-pane">
        <button class="btn btn-primary block" @click="newEntry">＋ 新規ニュース</button>
        <input class="search" v-model="listFilter" type="text" placeholder="タイトルで検索…">
        <div class="list">
          <button
            v-for="item in filteredNews"
            :key="item.id"
            class="list-item"
            :class="{ active: item.id === editingId }"
            @click="selectNews(item)">
            <span class="li-date">{{ item.fmtDatetime.dateFmt }}</span>
            <span class="li-title">{{ item.title }}</span>
          </button>
          <p v-if="filteredNews.length === 0" class="empty">該当するニュースがありません</p>
        </div>
      </aside>

      <!-- 入力フォーム -->
      <section class="form-pane">
        <div class="form-head">
          <h2 class="head-title">
            <span class="mode" :class="editingId ? 'mode-edit' : 'mode-new'">
              {{ editingId ? '編集中' : '新規' }}
            </span>
            ニュース登録
          </h2>
          <div class="actions">
            <button class="btn btn-ghost" @click="newEntry">新規</button>
            <button class="btn btn-danger" :disabled="!editingId" @click="removeEntry">削除</button>
            <button class="btn btn-primary" @click="save">保存</button>
          </div>
        </div>

        <!-- 基本情報 -->
        <div class="card">
          <div class="card-title">基本情報</div>
          <label class="field">
            <span class="label">日時</span>
            <input type="datetime-local" v-model="form.datetime">
          </label>
          <label class="field">
            <span class="label">タイトル</span>
            <input type="text" v-model="form.title" placeholder="ニュースのタイトル">
          </label>
          <label class="field">
            <span class="label">サブタイトル</span>
            <input type="text" v-model="form.subTitle" placeholder="任意">
          </label>
          <label class="field">
            <span class="label">内容</span>
            <textarea v-model="form.content" rows="10" placeholder="本文"></textarea>
          </label>
        </div>

        <!-- 画像 -->
        <div class="card">
          <div class="card-title">画像</div>
          <p class="hint">複数枚アップロードできます。</p>
          <input type="file" accept="image/*" @change="uploadImage($event)">
          <div class="img-grid" v-if="form.images.length">
            <div class="img-thumb" v-for="(name, i) in form.images" :key="i">
              <img :src="imageUrl(name)" alt="">
              <button class="img-remove" @click="removeImage(i)" title="削除">×</button>
            </div>
          </div>
        </div>

        <div class="actions actions-bottom">
          <button class="btn btn-ghost" @click="newEntry">新規</button>
          <button class="btn btn-danger" :disabled="!editingId" @click="removeEntry">削除</button>
          <button class="btn btn-primary" @click="save">保存</button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import firebase from "../main.js";
import { collection, doc, addDoc, setDoc, getDocs, deleteDoc } from "firebase/firestore";
import { getStorage, ref, uploadBytes } from "firebase/storage";

const BUCKET = "farmy-demo.appspot.com";
const STORAGE_DIR = "news-contents-image/";

function emptyForm() {
  return {
    title: '',
    subTitle: '',
    content: '',
    datetime: '',
    images: [],
  };
}

export default {
  name: 'NewsRegist',
  data() {
    return {
      news: [],
      editingId: null,
      listFilter: '',
      form: emptyForm(),
    };
  },
  computed: {
    filteredNews() {
      const q = this.listFilter.trim().toLowerCase();
      if (!q) return this.news;
      return this.news.filter((n) => (n.title || '').toLowerCase().includes(q));
    },
  },
  mounted() {
    this.fetchNews();
  },
  methods: {
    toDateTime(datetime) {
      var date = new Date(1970, 0, 1);
      date.setSeconds(datetime.seconds);
      date.setHours(date.getHours() + 9);
      return {
        dateFmt: date.getFullYear() + "/" + ("00" + (date.getMonth() + 1)).slice(-2) + "/" + ("00" + date.getDate()).slice(-2),
        timeFmt: ("00" + date.getHours()).slice(-2) + ":" + ("00" + date.getMinutes()).slice(-2),
        datetimeVal: date.getFullYear()
          + "-" + ("00" + (date.getMonth() + 1)).slice(-2)
          + "-" + ("00" + date.getDate()).slice(-2)
          + "T" + ("00" + date.getHours()).slice(-2)
          + ":" + ("00" + date.getMinutes()).slice(-2),
      };
    },
    async fetchNews() {
      this.news = [];
      const snap = await getDocs(collection(firebase.db, "News"));
      snap.forEach((d) => {
        const data = d.data();
        data.id = d.id;
        data.fmtDatetime = this.toDateTime(data.datetime);
        this.news.push(data);
      });
      this.news.sort((a, b) => b.datetime - a.datetime);
    },
    newEntry() {
      this.editingId = null;
      this.form = emptyForm();
    },
    selectNews(item) {
      this.editingId = item.id;
      const f = emptyForm();
      f.title = item.title || '';
      f.subTitle = item.subTitle || '';
      f.content = item.content || '';
      f.datetime = item.fmtDatetime.datetimeVal;
      f.images = item.imageurls ? [...item.imageurls] : [];
      this.form = f;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    buildData() {
      const f = this.form;
      return {
        title: f.title,
        subTitle: f.subTitle,
        content: f.content,
        datetime: new Date(f.datetime),
        updateDate: new Date(),
        imageurls: f.images,
      };
    },
    async save() {
      if (!this.form.title.trim()) { alert("タイトルを入力してください"); return; }
      if (!this.form.datetime) { alert("日時を入力してください"); return; }
      const data = this.buildData();
      if (this.editingId) {
        await setDoc(doc(firebase.db, "News", this.editingId), data);
        alert("ニュースを更新しました");
      } else {
        data.createDate = new Date();
        await addDoc(collection(firebase.db, "News"), data);
        alert("ニュースを登録しました");
      }
      await this.fetchNews();
      this.newEntry();
    },
    async removeEntry() {
      if (!this.editingId) return;
      if (!confirm(`「${this.form.title}」を削除してもいいですか？`)) return;
      await deleteDoc(doc(firebase.db, "News", this.editingId));
      alert("削除しました");
      await this.fetchNews();
      this.newEntry();
    },
    imageUrl(filename) {
      if (!filename) return '';
      const path = encodeURIComponent(STORAGE_DIR + filename);
      return `https://firebasestorage.googleapis.com/v0/b/${BUCKET}/o/${path}?alt=media`;
    },
    uploadImage(event) {
      const file = event.target.files[0];
      if (!file) return;
      const storage = getStorage();
      const storageRef = ref(storage, STORAGE_DIR + file.name);
      uploadBytes(storageRef, file).then((snapshot) => {
        this.form.images.push(snapshot.metadata.name);
      });
      event.target.value = '';
    },
    removeImage(index) {
      this.form.images.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.regist {
  --gold: #AF9453;
  --gold-dark: #937b3f;
  --danger: #c0392b;
  --border: #e3ddcd;
  --bg: #faf8f3;
  --text: #3a3630;
  color: var(--text);
  text-align: left;
  padding: 16px;
  max-width: 1200px;
  margin: 0 auto;
}
.layout { display: flex; gap: 20px; align-items: flex-start; }

/* 一覧 */
.list-pane { width: 300px; flex-shrink: 0; position: sticky; top: 12px; }
.search {
  width: 100%; margin: 10px 0; padding: 8px 10px;
  border: 1px solid var(--border); border-radius: 8px; font-size: 14px;
}
.list {
  border: 1px solid var(--border); border-radius: 10px; background: #fff;
  max-height: 70vh; overflow-y: auto;
}
.list-item {
  display: grid; gap: 2px; width: 100%; text-align: left;
  padding: 10px 12px; border: none; border-bottom: 1px solid #f0ece1;
  background: #fff; cursor: pointer;
}
.list-item:hover { background: var(--bg); }
.list-item.active { background: #f3ecd9; box-shadow: inset 3px 0 0 var(--gold); }
.li-date { font-size: 12px; color: #9a927f; }
.li-title { font-size: 14px; font-weight: 600; line-height: 1.3; }
.empty { padding: 16px; color: #9a927f; font-size: 13px; }

/* フォーム */
.form-pane { flex: 1; min-width: 0; }
.form-head {
  position: sticky; top: 0; z-index: 5;
  display: flex; justify-content: space-between; align-items: center;
  gap: 12px; flex-wrap: wrap;
  background: rgba(250, 248, 243, 0.95); backdrop-filter: blur(4px);
  padding: 8px 0 12px; margin-bottom: 8px; border-bottom: 1px solid var(--border);
}
.head-title { font-size: 20px; font-weight: 700; display: flex; align-items: center; gap: 10px; }
.mode { font-size: 12px; font-weight: 700; padding: 3px 10px; border-radius: 999px; }
.mode-new { background: #eef4e8; color: #4d7a2f; }
.mode-edit { background: #f3ecd9; color: var(--gold-dark); }
.actions { display: inline-flex; gap: 8px; }
.actions-bottom { justify-content: flex-end; margin-top: 16px; }

.card {
  background: #fff; border: 1px solid var(--border); border-radius: 12px;
  padding: 18px; margin-bottom: 16px;
}
.card-title {
  font-size: 15px; font-weight: 700; color: var(--gold-dark);
  margin-bottom: 14px; padding-bottom: 8px; border-bottom: 2px solid #f0ece1;
}
.hint { font-size: 12px; color: #9a927f; margin: -6px 0 12px; }

.field { display: block; margin-bottom: 14px; }
.label { display: block; font-size: 13px; font-weight: 600; margin-bottom: 5px; color: #6b6555; }

input[type="text"],
input[type="datetime-local"],
textarea {
  width: 100%; padding: 9px 11px; border: 1px solid var(--border);
  border-radius: 8px; font-size: 14px; font-family: inherit; background: #fff; box-sizing: border-box;
}
input:focus, textarea:focus {
  outline: none; border-color: var(--gold); box-shadow: 0 0 0 3px rgba(175, 148, 83, 0.15);
}
textarea { resize: vertical; line-height: 1.5; }

/* 画像 */
.img-grid { display: flex; flex-wrap: wrap; gap: 10px; margin-top: 12px; }
.img-thumb { position: relative; }
.img-thumb img {
  width: 130px; height: 100px; object-fit: cover;
  border-radius: 8px; border: 1px solid var(--border);
}
.img-remove {
  position: absolute; top: -8px; right: -8px;
  width: 22px; height: 22px; border-radius: 50%;
  border: none; background: var(--danger); color: #fff;
  font-size: 14px; line-height: 1; cursor: pointer;
}

/* ボタン */
.btn {
  padding: 9px 18px; border-radius: 8px; font-size: 14px; font-weight: 700;
  cursor: pointer; border: 1px solid transparent; transition: filter 0.15s, background 0.15s;
}
.btn.block { width: 100%; }
.btn-primary { background: var(--gold); color: #fff; }
.btn-primary:hover { filter: brightness(1.06); }
.btn-ghost { background: #fff; color: var(--gold-dark); border-color: var(--border); }
.btn-ghost:hover { background: var(--bg); }
.btn-danger { background: #fff; color: var(--danger); border-color: #e3b7b1; }
.btn-danger:hover { background: #fdeeec; }
.btn-danger:disabled { color: #c9c3b5; border-color: var(--border); cursor: not-allowed; background: #fff; }

/* レスポンシブ */
@media screen and (max-width: 860px) {
  .layout { flex-direction: column; }
  .list-pane { width: 100%; position: static; }
  .list { max-height: 260px; }
}
</style>
